module.exports = __webpack_public_path__ + "static/img/fun4.7248a92d.png";